var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudWithCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "none",
    d: "m13.507 5.5053c2.5558 0 4.6538 1.9557 4.8814 4.4522 1.7021 0.60588 2.9211 2.2306 2.9211 4.1415-1.84e-4 2.427-1.9677 4.3946-4.3947 4.3947h-10.572c-2.0179 0-3.6538-1.6359-3.6539-3.6538 0-1.398 0.78569-2.6094 1.9369-3.2238 0.13267-1.7797 1.6174-3.1824 3.4312-3.1824 0.31474 0 0.61975 0.042592 0.90965 0.12212 0.73074-1.7892 2.4874-3.0503 4.5401-3.0504z",
    strokeWidth: 1.3793
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.896 9.6432c2.5392 0 4.5976-2.0584 4.5976-4.5976s-2.0584-4.5976-4.5976-4.5976-4.5976 2.0584-4.5976 4.5976 2.0584 4.5976 4.5976 4.5976z",
    strokeWidth: 0.91953
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.461 7.2879-1.6815-1.7997c-0.23016-0.24639-0.21701-0.63621 0.02942-0.86641 0.24634-0.23021 0.63622-0.21696 0.86638 0.029397l1.2971 1.3882 2.053-1.9182c0.01848-0.017269 0.03779-0.033094 0.05775-0.047641l0.96541-0.90205c0.24643-0.2302 0.63631-0.21695 0.86647 0.029434 0.23016 0.24636 0.21692 0.63621-0.02942 0.86642l-2.9488 2.7551-0.0031-0.00337-1.02 0.95305z",
    strokeWidth: 0.91953
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudWithCheck);
export default __webpack_public_path__ + "static/media/cloud-with-check.506ce2eca911ac89413eb4472a74b65b.svg";
export { ForwardRef as ReactComponent };